import { DirectionalDrillingWidgetWrapper } from '../../directional-drilling-widget/DirectionalDrillingWidget';
import type { DirectionalDrillingWidgetEntity } from '../../directional-drilling-widget/DirectionalDrillingWidget.entity';

import type { TRenderWidget, TWidgetRendererOptions } from './WidgetRendererService';

export function renderDirectionalDrillingWidget(
  widget: DirectionalDrillingWidgetEntity,
  options: TWidgetRendererOptions,
): TRenderWidget {
  return ({ onCreateDirectionalDrillingWidget }) => (
    <DirectionalDrillingWidgetWrapper
      entity={widget}
      options={options}
      onCreateDirectionalDrillingWidget={onCreateDirectionalDrillingWidget}
    />
  );
}
